module.exports = __webpack_public_path__ + "img/logo.f0862092.svg";